<template>
    <div :class="{ focus: focus || openedResult || isShowHistory }" class="search-product">
        <!--!TODO: порефакторить. вынести в компоненты.        -->

        <div class="search-container">
            <IconSearch class="icon search" />

            <Overflow ref="overflow"
                      :elements="tags"
                      :to-title="it => it.name"
                      class="tags product-tag">
                <template #default="{ item }">
                    <div :class="[item.class]" class="item">
                        <span class="text">#{{ item.name }}</span>
                        <IconCloseMini class="close" @click="removeTag(item)" />
                    </div>
                </template>
            </Overflow>

            <input ref="search"
                   v-model.trim="searchText"
                   :maxlength="MAX_SEARCH_LENGTH"
                   autocomplete="off"
                   class="search-input"
                   name="search"
                   placeholder="Поиск по тексту и #тегам"
                   tabindex="1"
                   type="text"
                   @focus="onFocus"
                   @click="open"
                   @focusin="focus = true"
                   @input="onInput()"
                   @keyup.enter="emitSearch()"
            >
            <div v-show="tagsInText.length && openedResult" class="tab">TAB</div>
            <button v-show="!emptyQuery || !emptyTags" class="only-icon no-border close" @click="onClear">
                <IconClose class="icon clear" />
            </button>
        </div>

        <Transition name="slide-top">
            <div v-show="openedResult || isShowHistory" ref="resultContainer" class="result">
                <div v-show="isShowHistory" class="container">
                    <SearchHistory ref="history" @select="changeSearch" />
                </div>

                <div v-show="status && status !== 'success'" class="message">
                    <div v-show="status === 'waiting'"
                         class="loading">
                        <slot :searchText="lastSearchText"
                              name="loading"
                        >
                            <Loader class="loader" />
                        </slot>
                    </div>
                    <div v-show="status === 'failure'"
                         class="failure">
                        <slot :message="message"
                              :searchText="lastSearchText"
                              name="failure"
                        >{{ message }}
                        </slot>
                    </div>
                </div>

                <div v-show="openedResult" class="container">
                    <template v-if="!viewTag">
                        <TransitionGroup name="slide-top" tag="div">
                            <div v-for="(it, i) in options"
                                 :key="i + 'text'"
                                 ref="option"
                                 :class="{ active: i === $focusedOptionIndex }"
                                 class="option"
                                 @click="onSelectText(it)"
                            >
                                <slot :item="it"
                                      :title="it.name"
                                      name="option"
                                >
                                    <span class="text" v-html="foundPattern(it.name)"></span>
                                </slot>
                            </div>
                        </TransitionGroup>
                    </template>
                    <template v-else>
                        <TransitionGroup name="slide-top" tag="div">
                            <NodeTag v-for="(it) in optionsTagsMap"
                                     :key="'tag-' + it.id"
                                     :flat-groups="true"
                                     :selectedMap="selectedTagMap"
                                     :value="it"
                                     @selected="onSelectTag($event)" />
                        </TransitionGroup>
                    </template>
                </div>

                <div v-show="openedResult">
                    <slot :searchText="searchText"
                          name="absent">
                        <div ref="option"
                             :class="{ active: $refs.option?.length === $focusedOptionIndex }"
                             class="option message"
                             @click="emitSearch">
                            Искать по: «{{ textSearchBy }}»
                        </div>
                    </slot>
                </div>


                <div v-if="showExtendedSearch"
                     ref="extendedSearch"
                     :class="{ collapsed: collapsedExtendedSearch }"
                     class="extended-search">
                    <div class="title">
                        <button class="no-border iconed" @click="toggleExtendedSearch">
                            <IconChevronDown class="icon" />
                            <span>Расширенный поиск по категориям</span>
                        </button>
                    </div>

                    <Transition name="slide-top">
                        <div v-show="!collapsedExtendedSearch" class="categories">
                            <div class="actions">
                                <button class="no-border accent"
                                        @click="toggleAllExtendedSearch(true)">
                                    Выбрать все
                                </button>
                                <button :disabled="!extendedSearch.length"
                                        class="no-border"
                                        @click="toggleAllExtendedSearch(false)">
                                    Сбросить
                                </button>
                            </div>

                            <div class="category">
                                <div class="title">Продукт</div>

                                <div class="items badges">
                                    <div v-for="(it, i) in dicts.productSearchFields" :key="i"
                                         :class="{
                                    active: extendedSearchSelectedMap[it.key],
                                    disabled: it.disabled
                                 }"
                                         class="item"
                                         @click="toggleExtendedSearchItem(it)">
                                        <span class="text">{{ it.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import {
    productSearchFieldOptions,
} from '@/common/page_comp/SearchProduct/extended.search.util.js';
import { lastWordTag } from '@/common/page_comp/SearchProduct/util.js';
import { tagsToMap } from '@/common/page_comp/Tag/util.js';
import { allTags } from '@/restapi/tag/tag.js';
import { toMap } from '@dsee/util/arrays';
import { foundByPattern, limitValue, removeLastWord } from '@/common/util/util.js';
import Timer from '@dsee/util/timer.js';

import IconSearch from '@/common/page_comp/SearchProduct/icons/search.svg?component';
import IconClose from '@/common/page_comp/SearchProduct/icons/close.svg?component';

import SearchHistory from '@/common/page_comp/SearchProduct/comp/SearchHistory.vue';
import NodeTag from '@/common/comp/selects/node.vector.vue';


const toInternal = (item) => {
    const title = '#' + item.name;
    const key = item.id;
    const nested = (item.options ?? []).map(toInternal);
    const disabled = item.disabled;
    const visible = true;

    return { title, item, key, nested, disabled, visible };
};

const tagRegExp = /#[a-zA-Zа-яА-Я0-9_]+/g;

function extractTextTags(text) {
    const matched = text.match(tagRegExp) ?? [];
    return matched.map(tag => tag.slice(1).toLowerCase());
}

const MAX_SEARCH_LENGTH = 255;

export default {
    components: {
        SearchHistory,
        NodeTag,
        IconSearch,
        IconClose,
    },
    props: {
        suggest: {
            type: Function,
            required: true,
        },
        suggestTag: {
            type: Function,
            required: true,
        },
        searchDelay: {
            type: Number,
            default: 300,
        },
        extendedSearch: {
            type: Array,
            default: () => [],
        },
        showExtendedSearch: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [],
            optionsTags: [],

            searchText: '',
            selectedTags: [],
            lastSearchText: null,

            message: '',
            status: '',

            openedHistory: false,
            openedResult: false,
            focus: false,
            collapsedExtendedSearch: true,

            focusedOptionIndex: -1,

            dicts: {
                allTags: [],
                productSearchFields: productSearchFieldOptions.nested,
            },
        };
    },
    computed: {
        MAX_SEARCH_LENGTH() {
            return MAX_SEARCH_LENGTH;
        },
        emptyQuery() {
            return !this.searchText.trim().length;
        },
        emptyTags() {
            return this.selectedTags.length === 0;
        },
        isEmpty() {
            if (this.viewTag)
                return this.optionsTags.length === 0;

            return this.options.length === 0;
        },
        selectedTagMap() {
            return toMap(this.selectedTags);
        },
        optionsTagsMap() {
            return this.optionsTags.map(toInternal);
        },
        tags() {
            const tags = this.selectedTags;
            return tagsToMap(tags);
        },
        lastWordTag() {
            return lastWordTag(this.searchText);
        },
        viewTag() {
            return this.lastWordTag !== null;
        },
        allTagsNameMap() {
            return toMap(this.dicts.allTags, (it) => it.name.toLowerCase());
        },
        allTagsMap() {
            return toMap(this.dicts.allTags);
        },
        tagsInText() {
            const result = new Set();
            const tagNames = extractTextTags(this.searchText);

            for (const tagName of tagNames) {
                const tag = this.allTagsNameMap[tagName];
                if (tag)
                    result.add(this.allTagsNameMap[tagName]);
            }

            return Array.from(result);
        },
        isShowHistory() {
            return this.emptyTags && this.emptyQuery && this.openedHistory;
        },
        $focusedOptionIndex: {
            get() {
                return this.focusedOptionIndex;
            },
            set(index) {
                if (!this.$refs.option)
                    return;
                const max = this.$refs.option.length ?? 0;
                this.focusedOptionIndex = limitValue(index, -1, max);
            },
        },
        textSearchBy() {
            const text = this.selectedTags
                             .map(it => '#' + it.name)
                             .join(' ') + ' ' + this.searchText;

            return text.trim();
        },
        foundPattern() {
            return foundByPattern(this.searchText);
        },
        $extendedSearch: {
            get() {
                return this.extendedSearch;
            },
            set(value) {
                this.$emit('update:extendedSearch', value);
            },
        },
        extendedSearchSelectedMap() {
            const map = {};
            for (const it of this.dicts.productSearchFields) {
                if (this.$extendedSearch.includes(it.key) && !it.disabled)
                    map[it.key] = it;
            }

            return map;
        },
    },
    methods: {
        async doSearch(searchText = '') {
            this.$options.searchTimer.clearTimeout();

            if (this.lastSearchText === searchText) {
                this.openedResult = true;
                return;
            }

            if (searchText.trim() === '')
                return;

            this.lastSearchText = searchText;

            if (this.viewTag) {
                await this.searchTags(this.lastWordTag);
            } else {
                await this.searchQuery(searchText);
            }
        },
        async searchQuery(searchText) {
            this.status = 'waiting';
            this.message = '';

            try {
                this.options = await this.suggest(searchText);
                this.status = 'success';
            } catch (e) {
                console.error(e);
                this.options = [];
                this.status = 'failure';
                this.message = e.message;
            }
        },
        async searchTags(searchText) {
            this.status = 'waiting';
            this.message = '';

            try {
                this.optionsTags = await this.suggestTag(searchText);
                this.status = 'success';
            } catch (e) {
                console.error(e);
                this.optionsTags = [];
                this.status = 'failure';
                this.message = e.message;
            }
        },
        onClear() {
            this.searchText = '';
            this.selectedTags = [];
            this.emitSearch();
        },
        onInput() {
            if (!this.emptyQuery || !this.emptyTags) {
                this.openedResult = true;
                this.lazySearch();
            } else {
                this.openedResult = false;
                this.openedHistory = true;
            }
        },
        onFocus() {
            this.onInput();

            if (this.$extendedSearch.length)
                this.collapsedExtendedSearch = false;
        },
        focusIn() {
            this.focus = true;
            this.$refs.search.focus();
        },
        async onSelectText(item) {
            this.searchText = item.name;
            this.emitSearch();

            const res = this.$router.resolve({
                name: 'product',
                params: {
                    id: item.id,
                },
            });

            window.open(res.href, '_blank');

            this.close();
        },
        onSelectTag(tag) {
            const { item, disabled, key } = tag;

            if (disabled)
                return;

            if (this.selectedTagMap[key]) {
                this.removeTag(item);
            } else {
                this.selectedTags.push(item);
            }

            this.searchText = removeLastWord(this.searchText);
            this.focusIn();
        },
        emitSearch() {
            const query = this.searchText.slice(0, MAX_SEARCH_LENGTH);
            const tagIds = this.selectedTags.map(tag => tag.id);
            this.$emit('search', query, tagIds);
            this.$refs.history.updateHistory();

            this.close();
        },
        lazySearch() {
            this.$options.searchTimer.setTimeout(
                () => this.doSearch(this.searchText),
                this.searchDelay,
            );
        },
        open() {
            this.focusIn();
            this.onFocus();
        },
        close() {
            this.openedResult = false;
            this.openedHistory = false;
            this.focus = false;
        },
        async changeSearch(source, tags, emit = true) {
            const tagsResult = [];

            // еба костыль
            if (!this.dicts.allTags.length)
                this.dicts.allTags = await allTags();

            for (const tag of tags) {
                tagsResult.push(this.allTagsMap[tag]);
            }

            this.searchText = source;
            this.selectedTags = tagsResult;

            if (emit)
                this.emitSearch();
        },
        onKeyEvent(e) {
            if (!this.openedResult)
                return;

            const options = this.$refs.option;

            switch (e.code) {
                case 'Escape':
                    this.openedResult = false;
                    this.openedHistory = false;
                    break;
                case 'Tab':
                    e.preventDefault();
                    this.text2Tags();
                    if (this.emptyQuery)
                        this.openedResult = false;
                    break;
                // управление фокусом по списку options на стрелки
                case 'ArrowDown':
                    e.preventDefault();
                    options[++this.$focusedOptionIndex].focus();
                    break;
                case 'ArrowUp':
                    e.preventDefault();

                    this.$focusedOptionIndex--;

                    if (this.$focusedOptionIndex < 0) {
                        this.$refs.search.focus();
                    } else {
                        options[this.$focusedOptionIndex].focus();
                    }

                    break;
                case 'Enter':
                    e.preventDefault();

                    if (this.viewTag)
                        break;
                    if (this.$focusedOptionIndex === options.length)
                        break;

                    if (this.$focusedOptionIndex >= 0)
                        this.onSelectText(this.options[this.$focusedOptionIndex]);

                    break;
            }
        },
        onMouseEvent(e) {
            if ((this.openedResult || this.openedHistory) && !this.$el.contains(e.target)) {
                this.close();
            }
        },
        removeTag(tag) {
            const index = this.selectedTags.findIndex(it => it.id === tag.id);
            if (index !== -1)
                this.selectedTags.splice(index, 1);

            this.emitSearch();
        },
        text2Tags() {
            // найти все существующие #Теги в searchText и превратить их в теги
            const tags = this.tagsInText;

            if (!tags.length)
                return;

            for (const tag of tags) {
                if (this.selectedTagMap[tag.id])
                    continue;

                this.selectedTags.push(tag);
            }

            // удалить все #Теги из searchText
            this.searchText = this.searchText.replace(tagRegExp, '');
        },
        toggleExtendedSearchItem(item) {
            if (item.disabled)
                return;

            const isSelected = this.extendedSearchSelectedMap[item.key];
            if (isSelected) {
                this.$extendedSearch = this.$extendedSearch.filter((field) => field !== item.key);
            } else {
                this.$extendedSearch.push(item.key);
            }
        },
        toggleAllExtendedSearch(flag) {
            if (flag) {
                this.$extendedSearch = this.dicts.productSearchFields.map(it => it.key)
            } else {
                this.$extendedSearch = [];
            }
        },
        toggleExtendedSearch() {
            this.collapsedExtendedSearch = !this.collapsedExtendedSearch;

            if (this.collapsedExtendedSearch === true)
                return;

            // метрика
            try {
                this.$metrika.reachGoal('advanced_search');
            } catch (e) {
                console.error('Не удалось отправить метрику: ' + e);
            }
        },
        openExtendedSearch() {
            if (!this.extendedSearch)
                return;

            this.open();
            this.$refs.extendedSearch.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });

            if (this.collapsedExtendedSearch === false)
                return;

            this.collapsedExtendedSearch = false;
            
            // метрика
            try {
                this.$metrika.reachGoal('advanced_search');
            } catch (e) {
                console.error('Не удалось отправить метрику: ' + e);
            }
        },
    },
    async created() {
        this.$options.searchTimer = new Timer();
        this.dicts.allTags = await allTags();
    },
    mounted() {
        document.addEventListener('keydown', this.onKeyEvent, true);
        document.addEventListener('click', this.onMouseEvent, true);
    },
    destroyed() {
        document.removeEventListener('keydown', this.onKeyEvent, true);
        document.removeEventListener('click', this.onMouseEvent, true);
    },
    watch: {
        searchText() {
            this.$focusedOptionIndex = -1;
        },
        openedResult(value) {
            if (value) {
                this.$focusedOptionIndex = -1;
            }
        },
        isShowHistory(value) {
            if (value) {
                this.$focusedOptionIndex = -1;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@dsee/mixins";

.search-product {
    position: relative;
    padding: 8px;
    padding-right: 0;
    border-radius: var(--input-border-radius);
    transition: var(--transition-function);

    &.focus {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 32px 32px 0px rgba(28, 41, 61, 0.06), 0px 0px 32px 0px rgba(28, 41, 61, 0.05);

        .search-container {
            border: var(--input-focus-border);
        }
    }

    .search-container {
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: var(--input-padding);
        padding-left: 42px;
        background-color: #fff;
        background: var(--input-background);
        box-shadow: var(--input-shadow);
        border: var(--input-border);
        border-radius: 56px;
        box-sizing: border-box;
        position: relative;
        transition: var(--transition-function);
        margin-right: 8px;

        &:hover {
            border: var(--input-hover-border);
        }

        .search-input,
        .search-input:hover,
        .search-input:focus {
            background-color: transparent;
            border: none !important;
            box-shadow: none !important;
        }

        .close {
            position: relative;
            z-index: 2;
        }

        & > .icon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            color: var(--theme-main-color);
            opacity: 0.5;

            &.search {
                left: 12px;
            }

            &.clear {
                right: 12px;
                cursor: pointer;
                padding: 8px 0;
            }
        }

        .tags {
            max-width: 70%;
            display: inline-flex;

            .item {
                display: inline-flex;
                align-items: center;

                .close {
                    cursor: pointer;
                    margin-left: 4px;
                    opacity: 0.4;
                }
            }
        }

        .tab {
            display: inline-flex;
            margin-left: 8px;
            background-color: var(--option-item-hover-background);
            border-radius: var(--input-border-radius);
            padding: 2px 4px;
            font-size: 10px;
            height: 16px;
            opacity: 0.7;
            user-select: none;
        }
    }

    .result {
        position: sticky;
        box-sizing: border-box;
        padding-top: 14px;
        width: 100%;
        max-height: 412px;
        overflow: auto;
        padding-right: 8px;
        margin-bottom: 10px;
        @include scrollbar;

        .container {
            position: relative;
        }

        .option,
        .message {
            display: block;
            padding: var(--input-padding);
            border-radius: var(--input-border-radius);
            overflow-wrap: anywhere;
            overflow: hidden;
        }

        .option {
            display: flex;
            align-items: center;
            cursor: pointer;

            &:hover {
                background: var(--option-hover-background);
            }

            &.active {
                background: var(--option-active-background)
            }

            &.disabled {
                color: var(--input-disabled-color);
            }

            .avatar {
                margin-right: 8px;
            }
        }

        .message {
            color: var(--input-disabled-color);
        }

        .extended-search {
            margin-top: 24px;
            padding: var(--input-padding);
            padding-top: 0;

            &:not(.collapsed) {
                > .title {
                    .icon {
                        transform: rotate(180deg);
                    }
                }
            }

            > .title {
                font-weight: 500;
                display: flex;
                align-items: center;

                button {
                    color: var(--text-color);

                    .icon {
                        margin-right: 4px;
                    }
                }
            }

            .categories {
                > .actions {
                    display: flex;
                    gap: 12px;
                    margin-bottom: 12px;
                    margin-top: 20px;
                }
            }

            .category {
                .title {
                    font-size: 12px;
                    line-height: 16px;
                    margin-bottom: 12px;
                }

                .items {
                    display: flex;
                    align-items: center;
                    flex-flow: row wrap;
                    gap: 8px;

                    .item {
                        cursor: pointer;
                        margin: 0;
                        transition: var(--transition-function);
                        border: 1px solid transparent;

                        &:not(.disabled, .active) {
                            background-color: rgba(255, 255, 255, 1);
                            border: var(--input-border);
                        }

                        &.active {
                            background-color: var(--theme-main-color);
                            color: #FFFFFF;
                            box-shadow: var(--input-shadow);
                        }

                        &.disabled {
                            background-color: rgba(225, 227, 232, 1);
                            color: rgba(181, 185, 195, 1);
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
span.found {
    background-color: var(--option-active-background);
}
</style>
